module.exports = __webpack_public_path__ + "static/media/italic.1cd91e2d.svg";